export const getDuration = (startTime: Date) => {
  const minutes = startTime.getMinutes();
  const seconds = startTime.getSeconds();

  return `${minutes < 10 ? `0${minutes}` : minutes}:${
    seconds < 10 ? `0${seconds}` : seconds
  }`;
};
